import React from 'react';
import success from 'assets/img/mobile-exito@3x.png';
import {
  Row, Col,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function Dashboard() {
  const { t } = useTranslation();
  return (
    <Row className="p-0 m-0">
      <Col md className="mt-5 card--light d-flex align-items-center justify-content-center flex-column">
        <img src={success} alt="Your card was saved sucessfully!" style={{ height: '30%' }} />
        <p>{t( 'loading' )}</p>
        {/* <p>
            -
            {localStorage.getItem( 'jwt' )}
            -
            {reRender}
            -
            {JSON.stringify( cookies )}
            -
            {initAPP}
          </p>
          <Button onClick={() => {
            setReRender( new Date().valueOf() );
          }}
          >
            reload
          </Button> */}
      </Col>
    </Row>
  );
}
export default Dashboard;
